import { Layout, Row, Skeleton, Space, theme } from 'antd';
import CustomDivider from '../../../components/CustomDivider';
import { MAIN_SIDEBAR_WIDTH, TAB_BAR_HEIGHT, TICKET_FOOTER_HEIGHT, TICKET_SIDEBAR_WIDTH } from '../../../styles/theme';

const { Content, Footer, Sider } = Layout;

export default function LoadingTicketPageLayout() {
    const {
        token: { colorBgLayout, colorSplit, lineWidth, marginXXL, padding, paddingMD, paddingSM }
    } = theme.useToken();

    return (
        <Layout className="full-height" hasSider>
            <Sider
                width={TICKET_SIDEBAR_WIDTH}
                theme="light"
                style={{
                    padding: paddingSM,
                    backgroundColor: colorBgLayout,
                    borderInlineEnd: `${lineWidth}px solid ${colorSplit}`,
                    height: `calc(100vh - ${TAB_BAR_HEIGHT}px)`,
                    overflowY: 'auto'
                }}
            >
                <Skeleton.Input size="small" active className="full-width" style={{ marginBottom: marginXXL }} />
                <Space size={marginXXL} direction="vertical" className="full-width">
                    <Skeleton.Input active className="full-width" />
                    <Space direction="vertical" className="full-width" size="large">
                        <Skeleton.Input active className="full-width" />
                        <Skeleton.Input active className="full-width" />
                        <Skeleton.Input active className="full-width" />
                        <Skeleton.Input active className="full-width" />
                        <Skeleton.Input active className="full-width" />
                    </Space>
                </Space>
            </Sider>

            <Layout style={{ height: `calc(100% - ${TICKET_FOOTER_HEIGHT}px)` }}>
                <Row
                    align="middle"
                    justify="space-between"
                    style={{
                        paddingBottom: paddingSM,
                        paddingLeft: paddingSM,
                        paddingRight: paddingSM,
                        paddingTop: paddingMD,
                        borderBottom: `${lineWidth}px solid ${colorSplit}`
                    }}
                >
                    <Skeleton.Input active className="full-width" />
                    <CustomDivider zeroMargin />
                </Row>
                <Content
                    style={{
                        overflow: 'auto',
                        paddingBottom: paddingSM,
                        paddingLeft: paddingSM,
                        paddingRight: paddingSM,
                        paddingTop: 0
                    }}
                >
                    <Skeleton active className="full-width" />
                    <CustomDivider zeroMargin />
                    <Skeleton active className="full-width" />
                    <CustomDivider zeroMargin />
                    <Skeleton active className="full-width" />
                </Content>
                <Footer
                    style={{
                        bottom: 0,
                        height: TICKET_FOOTER_HEIGHT,
                        padding,
                        position: 'absolute',
                        width: `calc(100% - ${TICKET_SIDEBAR_WIDTH}px - ${MAIN_SIDEBAR_WIDTH}px)`
                    }}
                >
                    <Row justify="space-between" wrap={false}>
                        <Space size="middle">
                            <Skeleton.Button active style={{ width: 350 }} />
                        </Space>
                        <Space size="middle">
                            <Skeleton.Button active />
                            <Skeleton.Button active style={{ width: 150 }} />
                        </Space>
                    </Row>
                </Footer>
            </Layout>
        </Layout>
    );
}
